import { apiCweb } from './api-cweb';
import { DbProject, ContactInformationVM } from '~src/types/db';
import { appLog } from '~src/utils/log';

interface LoadProjectParams {
  projectId: number;
  extended_project_data?: boolean;
  extended_contract_data?: boolean;
  extended_customer_data?: boolean;
}

export const getProjectsList = async () => {
  appLog('loadProjectsList');
  const res = await apiCweb.get<DbProject[]>('/projects?pweb_accessible=true');
  return res.data;
};

export const loadProject = async (
  key,
  {
    projectId,
    extended_project_data = true,
    extended_contract_data = true,
    extended_customer_data = true,
  }: LoadProjectParams
) => {
  appLog('loadProject ->', {
    projectId,
    extended_project_data,
    extended_contract_data,
    extended_customer_data,
  });
  const res = await apiCweb.get<DbProject>(
    `/projects/${projectId}?extended_project_data=${extended_project_data}&extended_contract_data=${extended_contract_data}&extended_customer_data=${extended_customer_data}`
  );
  return res.data;
};

export const getProjectContactsList = async (
  key,
  { projectId }: LoadProjectParams
) => {
  appLog('getProjectContactsList');
  const res = await apiCweb.get<ContactInformationVM[]>(
    `/projects/${projectId}/contacts`
  );

  // console.log(`getProjectContactsList:`, res.data);
  return res.data;
};

export const createProjectContact = async (projectId, contactData) => {
  appLog('createProjectContact', { projectId, contactData });
  const res = await apiCweb.post<ContactInformationVM[]>(
    `/projects/${projectId}/contacts`,
    contactData
  );

  return res.data;
};

export const patchProjectContact = async (
  projectId: number,
  contact_key: number,
  contactData
) => {
  appLog('createProjectContact', { projectId, contact_key, contactData });
  const res = await apiCweb.patch<ContactInformationVM[]>(
    `/projects/${projectId}/contacts/${contact_key}`,
    contactData
  );

  return res.data;
};

export const deleteProjectContact = async (projectId, contact_key) => {
  appLog('deleteProjectContact', { projectId, contact_key });
  const res = await apiCweb.delete(
    `/projects/${projectId}/contacts/${contact_key}`
  );

  return res.data;
};
